import SmallFooter from "./SmallFooter"
import CookieConsent from "react-cookie-consent"
import { useLang } from "hooks/useLang"
import Image from "next/image"
import VisaIcon from "components/icons/VisaIcon"
import MasterCardIcon from "components/icons/MasterCardIcon"
import StcPayIcon from "components/icons/StcPayIcon"
import ApplePayIcon from "components/icons/ApplePayIcon"
import AmericanExpressIcon from "components/icons/AmericanExpressIcon"
import MadaIcon from "components/icons/MadaIcon"
import Link from "next/link"
import AppSocialMedia from "components/atoms/AppSocialMedia"
import TabbyIcon from "components/icons/TabbyIcon"

export const FOOTER_LINKS = [
    {
        title: "explore",
        linkTo: "/events",
    },
    {
        title: "who_are_we",
        linkTo: "/company/about-us",
    },
    {
        title: "footerLink_contactUs",
        linkTo: "/support/contact-us",
    },
    {
        title: "create_your_event",
        linkTo: "/support/create-event",
    },
]

export default function Footer() {
    const { t, isAr } = useLang()

    const position = isAr ? "right" : "left"

    return (
        <footer className="min-h-80 hidden md:block">
            <CookieConsent
                buttonText={t("cookie_button_text")}
                contentStyle={{
                    color: "white",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "0.9rem",
                    padding: "1rem 2rem",
                    fontWeight: "300",
                }}
                buttonStyle={{
                    backgroundColor: " #2741CC",
                    color: "white",
                    borderRadius: "5px",
                    padding: "0.5rem 1rem",
                    fontSize: "1rem",
                    fontWeight: "bold",
                }}
                acceptOnScroll={true}
            >
                {t("COOKIES_CONSENT_MESSAGE")}
            </CookieConsent>

            <div className="relative flex h-[325px] flex-col overflow-hidden bg-white shadow-[0_0_9px_5px_rgba(0,0,0,0.05)] dark:bg-[#3A2B87]">
                <div
                    className={`absolute ${position}-0 pointer-events-none top-0 h-full w-2/3 scale-150  opacity-70`}
                >
                    <Image
                        src={"/svg/v2/footer_bg.webp"}
                        alt="footer_bg"
                        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                        style={{ objectFit: "cover" }}
                        fill
                        priority
                    />
                </div>

                <div className="layout relative h-full w-full py-10">
                    <div className="flex items-center justify-between">
                        <div className="pointer-events-none flex flex-col items-center gap-2">
                            <Image
                                src="/svg/v2/footer-logo-v2.png"
                                alt="Footer-logo"
                                className="block h-auto w-auto dark:hidden"
                                style={{
                                    objectFit: "contain",
                                }}
                                height={120}
                                width={170}
                            />
                            <Image
                                src="/svg/v2/footer-logo-white-v2.png"
                                alt="Footer-logo"
                                className="hidden h-auto w-auto dark:block"
                                style={{
                                    objectFit: "contain",
                                }}
                                height={120}
                                width={170}
                            />
                            <span className="text-xs font-bold text-primary-theme-500 dark:text-white">
                                {t("made_in_saudi")}
                            </span>
                        </div>

                        <div className="flex  items-center gap-5 lg:gap-10">
                            {FOOTER_LINKS.map((item, index: number) => (
                                <Link
                                    href={item.linkTo}
                                    className="cursor-pointer text-sm capitalize text-black transition-all hover:text-gray-600 hover:underline dark:text-white"
                                    key={index}
                                >
                                    {t(item.title)}
                                </Link>
                            ))}
                        </div>

                        <AppSocialMedia width={180} />
                    </div>
                    <div className="flex items-center justify-center gap-5 pt-10">
                        <div className="flex items-center gap-2">
                            <VisaIcon width={"100%"} height={32} />
                            <MasterCardIcon width={"100%"} height={32} />
                            <StcPayIcon width={"100%"} height={32} />
                            <ApplePayIcon width={"100%"} height={32} />
                            <AmericanExpressIcon width={"100%"} height={32} />
                            <MadaIcon width={"100%"} height={32} />
                            <TabbyIcon width={"100%"} height={32} />

                        </div>
                    </div>
                    <hr className="my-5" />
                    <SmallFooter />
                    <div className="my-2">
                        {isAr ? (
                            <div className="flex flex-row justify-between gap-4 text-xs">
                                <span className="text-xs text-black transition-all hover:text-gray-600 dark:text-white">
                                    شركة محور البداية لتقنية نظم المعلومات
                                </span>
                                <span className="text-xs text-black transition-all hover:text-gray-600 dark:text-white">
                                    سجل تجاري رقم: 4030352391
                                </span>
                                <span className="text-xs text-black transition-all hover:text-gray-600 dark:text-white">
                                    ترخيص رقم: 2306070105 الصادر من الهيئة
                                    العامة للترفيه
                                </span>
                            </div>
                        ) : (
                            <div className="flex flex-row justify-between gap-4 text-xs">
                                <span className="text-xs text-black transition-all hover:text-gray-600 dark:text-white">
                                    Start-Hub Information Systems Technology
                                    Company Ltd
                                </span>
                                <span className="text-xs text-black transition-all hover:text-gray-600 dark:text-white">
                                    C.R: 4030352391
                                </span>
                                <span className="text-xs text-black transition-all hover:text-gray-600 dark:text-white">
                                    License No: 2306070105 issued by the General
                                    Entertainment Authority
                                </span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </footer>
    )
}
